import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import { Button } from "reactstrap";
import ErrorAlert from "../../../components/Modals/ErrorAlert";
import cloneDeep from "lodash/cloneDeep";
import SelectComponent from "../components/SelectComponent";
import CustomTooltip from "../components/CustomTooltip";
import { updateConfigurationsMap } from "../../../actions/configurations";

export const ConfigurationsMap = (props) => {
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const rowHeight = 24;

  useEffect(() => {
    // when clicking on "Update", dont do setRowData otherwise the table is refreshed
    if (rowData.length === 0) {
      setRowData(cloneDeep(props.configurationsMap));
    }
  }, [props.configurationsMap]);

  const columns_in_meters = [
    "max_elevation",
    "mean_elevation",
    "roughess_lulc",
  ];

  // redux is not updated, if you leave and get back then also data is back. Instead, if click on "Update" then also redux is updated
  const setValue = (params) => {
    setDisableButton(false); // allow button "Update" to be clickable
    var regExp = /[a-zA-Z]/g;
    var raise_error = false;
    if (
      params.newValue === "" ||
      params.newValue === undefined ||
      params.newValue === null
    ) {
      params.newValue = 0;
    } else if (
      regExp.test(String(params.newValue)) ||
      String(params.newValue).includes(",") ||
      String(params.newValue).includes(" ")
    ) {
      raise_error = true;
      params.newValue = params.oldValue;
    }
    if (raise_error === true) {
      ErrorAlert(
        "Format not valid! Cannot insert letters, commas or empty spaces"
      );
    } else {
      if (columns_in_meters.includes(params.column.colDef.field)) {
        params.data[params.column.colDef.field] = parseFloat(params.newValue);
      } else {
        params.data[params.column.colDef.field] =
          parseFloat(params.newValue) / 100;
      }
    }

    return params;
  };

  const getValue = (params) => {
    if (params.data !== undefined) {
      var num = params.data[params.column.colDef.field];
      if (!params.column.colDef.headerName.includes("bool")) {
        if (columns_in_meters.includes(params.column.colDef.field)) {
          num = Math.round((num + Number.EPSILON) * 100) / 100;
        } else {
          num = num * 100;
          num = Math.round((num + Number.EPSILON) * 100) / 100;
        }
      }
      return num;
    }
  };

  // when setting the value, remember that chosing the value from the list or by doing "paste" is different, so check for both
  const setSelect = (params) => {
    setDisableButton(false);
    if (params.newValue === "true" || params.newValue === "YES") {
      params.data[params.column.colDef.field] = true;
    } else if (params.newValue === "false" || params.newValue === "NO") {
      params.data[params.column.colDef.field] = false;
    } else {
      params.data[params.column.colDef.field] = null;
    }
    return params;
  };

  // getSelect is only used for the top value in the select editor (i.e. the value active)
  const getSelect = (params) => {
    if (params.data !== undefined) {
      if (params.data[params.column.colDef.field] === null) {
        return "INDIFFERENT";
      } else if (params.data[params.column.colDef.field] === true) {
        return "YES";
      } else if (params.data[params.column.colDef.field] === false) {
        return "NO";
      }
    }
  };

  const cellStyleSelect = (params) => {
    return { textAlign: "center" };
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  };

  return (
    <div style={{ padding: 20 }}>
      <h3 style={{ marginTop: 10, marginBottom: 0 }}>Configure Maps</h3>
      <p style={{ marginTop: 2, marginBottom: 15 }}>
        Choose thresholds to highlight recommended areas
      </p>
      <Button
        onClick={() => gridApi.expandAll()}
        color="primary"
        style={{
          height: 30,
          fontSize: 15,
          padding: "0px 10px",
        }}
      >
        Expand All
      </Button>
      <Button
        onClick={() => gridApi.collapseAll()}
        color="info"
        style={{
          marginLeft: 15,
          height: 30,
          fontSize: 15,
          padding: "0px 10px",
        }}
      >
        Collapse All
      </Button>
      <div style={{ marginTop: 10, marginBottom: 10 }}>
        <div
          style={{
            width: "100%",
            margin: "0px auto 0px auto",
            height: window.innerHeight - 230,
          }}
          className="ag-theme-balham"
        >
          <AgGridReact
            defaultColDef={{
              filter: true,
              sortable: true,
              resizable: true,
              editable: true,
              minWidth: 60,
              maxWidth: 600,
              width: 170,
              filterParams: { buttons: ["reset"] },
              cellStyle: (params) => {
                return { cursor: "default" };
              },
            }}
            autoGroupColumnDef={{
              headerName: "State and Region",
              cellRendererParams: {
                suppressCount: true,
              },
              pinned: "left",
            }}
            getContextMenuItems={(params) => [
              "copy",
              "copyWithHeaders",
              "paste",
              "separator",
              {
                name: "Export",
                icon: '<span class="ag-icon ag-icon-save" unselectable="on" role="presentation"></span>',
                subMenu: [
                  "csvExport",
                  {
                    name: "Excel Export (.xlsx)",
                    icon: '<span class="ag-icon ag-icon-excel" unselectable="on" role="presentation"></span>',
                    action: () => {
                      params.api.exportDataAsExcel({
                        sheetName: "Export",
                      });
                    },
                  },
                ],
              },
            ]}
            rowData={rowData.length === 0 ? null : rowData}
            getRowHeight={(params) => {
              return rowHeight;
            }}
            popupParent={document.body}
            suppressDragLeaveHidesColumns={true}
            stopEditingWhenGridLosesFocus={true}
            enableRangeSelection={true}
            onGridReady={onGridReady}
            frameworkComponents={{
              selectComponent: SelectComponent,
              customTooltip: CustomTooltip,
            }}
          >
            <AgGridColumn
              field="country"
              headerName="Country"
              rowGroup={true}
              editable={false}
              hide={true}
            />
            <AgGridColumn
              field="region"
              headerName="Region"
              rowGroup={true}
              editable={false}
              hide={true}
            />
            <AgGridColumn
              field="district"
              headerName="District"
              editable={false}
              pinned="left"
            />
            <AgGridColumn
              field="max_elevation"
              headerName="Max elevation (m)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Maximum altitude of the cell expressed in meters"
            />
            <AgGridColumn
              field="mean_elevation"
              headerName="Mean elevation (m)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Average altitude of the cell expressed in meters"
            />
            <AgGridColumn
              field="elev_1000_low_rate"
              headerName="Elev. below 1000m (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage of the area in the cell with an altitude less than 1000m"
            />
            <AgGridColumn
              field="slope_10_low_rate"
              headerName="Slope below 10% (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage of the area in the cell with a slope less than 10%"
            />
            <AgGridColumn
              field="roughess_lulc"
              headerName="Roughness LULC"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Roughness index of the area"
            />
            <AgGridColumn
              field="suitable_soil"
              headerName="Suitable soil rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell not covered by forest and water"
            />
            <AgGridColumn
              field="urban_area_rate"
              headerName="Urban area rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that intersects areas with more than 50.000 inhabitants"
            />
            <AgGridColumn
              field="suburb_area_rate"
              headerName="Suburban area rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that intersects the suburban area (50 km from urban areas)"
            />
            <AgGridColumn
              field="building_tot_rate"
              headerName="Building coverage (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that is covered by buildings"
            />
            <AgGridColumn
              field="desert_rate"
              headerName="Desert rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage of the area in the cell that is covered by desert"
            />
            <AgGridColumn
              field="park_rate"
              headerName="Park rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that is covered by protected areas"
            />
            <AgGridColumn
              field="artificial_lakes_rate"
              headerName="Artificial lake rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that is covered by artificial lakes"
            />
            <AgGridColumn
              field="militar_rate"
              headerName="Military rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that is covered by military zones"
            />
            <AgGridColumn
              field="airport_rate"
              headerName="Airport rate (%)"
              filter={"agNumberColumnFilter"}
              type={"numericColumn"}
              valueGetter={getValue}
              valueSetter={setValue}
              tooltipComponent="customTooltip"
              headerTooltip="Percentage in the cell that is covered by airports"
            />
            <AgGridColumn
              field="generation_index"
              headerName="Generating plant (bool)"
              cellStyle={cellStyleSelect}
              cellRenderer="selectComponent"
              cellEditor="agRichSelectCellEditor"
              cellEditorParams={{
                values: ["YES", "NO", "INDIFFERENT"],
              }}
              valueSetter={setSelect}
              valueGetter={getSelect}
              tooltipComponent="customTooltip"
              headerTooltip="Equal to YES if there is a thermal generation plant in the cell, else NO"
            />
            <AgGridColumn
              field="electric_line_index"
              headerName="Electric line (bool)"
              cellStyle={cellStyleSelect}
              cellRenderer="selectComponent"
              cellEditor="agRichSelectCellEditor"
              cellEditorParams={{
                values: ["YES", "NO", "INDIFFERENT"],
              }}
              valueSetter={setSelect}
              valueGetter={getSelect}
              tooltipComponent="customTooltip"
              headerTooltip="Equal to YES if there is an electric line in the cell, else NO"
            />
            <AgGridColumn
              field="road_index"
              headerName="Road index (bool)"
              cellStyle={cellStyleSelect}
              cellRenderer="selectComponent"
              cellEditor="agRichSelectCellEditor"
              cellEditorParams={{
                values: ["YES", "NO", "INDIFFERENT"],
              }}
              valueSetter={setSelect}
              valueGetter={getSelect}
              tooltipComponent="customTooltip"
              headerTooltip="Equal to YES if there is a primary road in the cell, else NO"
            />
          </AgGridReact>
        </div>
      </div>
      <div style={{ marginTop: 20 }}>
        <Button
          color="primary"
          size="lg"
          block
          disabled={disableButton}
          onClick={() => {
            var listRows = [];
            gridApi.forEachNode((rowNode) => {
              if (rowNode.data !== undefined) {
                listRows.push(rowNode.data);
              }
            });
            props.updateConfigurationsMap(listRows);
            setDisableButton(true);
          }}
        >
          Update recommended areas
        </Button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  configurationsMap: state.configurations.configurationsMap,
});

export default connect(mapStateToProps, { updateConfigurationsMap })(
  ConfigurationsMap
);
